import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'modal-component',
  templateUrl: './modal.component.html',
})
export class AppModalComponent {
  @Input() title!: string;
  @Input() content!: string;
  @Input() callback!: (() => void) | ((result: boolean) => void);

  constructor(
    public _dialogRef: MatDialogRef<AppModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}
}
